import { useCallback } from "react";
import PropTypes from "prop-types";
import toast from "react-hot-toast";
import { Box, Button, Divider, Popover, Typography } from "@mui/material";

import { useAuth } from "src/hooks/use-auth";
import { useRouter } from "src/hooks/use-router";
import { paths } from "src/paths";
import { Issuer } from "src/utils/auth";
import { getCommonError } from "src/utils/get-common-error";

export const AccountPopover = (props) => {
  const { open, anchorEl, onClose, ...other } = props;
  const router = useRouter();
  const { issuer, user, signOut } = useAuth();

  const handleLogout = useCallback(async () => {
    try {
      onClose?.();

      switch (issuer) {
        case Issuer.JWT: {
          await signOut(user.id, user.username);
          break;
        }

        default: {
          console.warn("Using an unknown Auth Issuer, did not log out");
        }
      }

      router.push(paths.auth.login);
    } catch (error) {
      const { message } = getCommonError(error);
      toast.error(message);
      console.error(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onClose, issuer, router, signOut]);

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: "center",
        vertical: "bottom",
      }}
      disableScrollLock
      onClose={onClose}
      open={!!open}
      PaperProps={{ sx: { width: 200 } }}
      {...other}
    >
      <Box sx={{ p: 2 }}>
        <Typography variant="body1">{user?.name}</Typography>
        <Typography
          color="text.secondary"
          variant="body2"
        >
          {user?.username}
        </Typography>
      </Box>
      <Divider />
      <Box
        sx={{
          display: "flex",
          p: 1,
          justifyContent: "center",
        }}
      >
        <Button
          color="inherit"
          onClick={handleLogout}
          size="small"
        >
          로그아웃
        </Button>
      </Box>
    </Popover>
  );
};

AccountPopover.propTypes = {
  open: PropTypes.bool,
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
};
